export { HeaderSkeleton } from './HeaderSkeleton';
export { RentSkeleton } from './RentSkeleton';
export { DocumentsSkeleton } from './DocumentsSkeleton';
export { CreditClimbCardSkeleton } from './CreditClimbCardSkeleton';
